<template>
  <div>
    <Breadcrumbs main="Usuarios" title="Personas"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label>Archivo a transformar</label>
                    <b-form-file
                        v-model="form.file.value"
                        name="file"
                        id="file_id"
                        :state="form.file.is_valid"
                        placeholder="Elije un archivo o arrástralo aquí..."
                        drop-placeholder="Arrastra un archivo aquí..."
                        browse-text="Explorar"
                    ></b-form-file>
                    <b-form-invalid-feedback :state="form.file.is_valid">{{form.file.message_error}}</b-form-invalid-feedback>
                  </div>
                </div>
                <div class="row">
                  <b-button type="button" variant="success" @click="onSubmit">Transformar archivo</b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import axios from 'axios';
import VueDropify from 'vue-dropify';
import utils from "@/utils";
export default {
  components: {
    'vue-dropify': VueDropify
  },
  data(){
    return{
      form: {
        file: utils.defaultFields()
      }
    }
  },
  mounted() {

  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let data = {};
      const is_valid = utils.generateJsonStructure(this.form, data);
      if(is_valid){
        let _formData = new FormData();
        if (!utils.isDict(data.file)) {
          delete data.file;
        }
        Object.keys(data).forEach(key => _formData.append(key, data[key]));
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `¿Estás seguro de realizar esta acción?.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            if(!this.objectId){
              const path = '/api/file/v1.0/file/';
              const headers = {'Content-Type': 'multipart/form-data'};
              await axios.post(path, _formData, {headers: headers}).then(async (response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'salida.csv'); //or any other extension
                document.body.appendChild(link);
                link.click();
                await this.$swal({
                  title: 'Transformado',
                  type: 'success',
                  html: `Se ha transformado el archivo de manera correcta.`,
                }).then((response) => {
                  this.form.file.value = null;
                });
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                if(error.response.status === 400){
                  utils.generateBackendError(this.form, error.response.data);
                  await this.$swal({
                    title: 'Error',
                    type: 'error',
                    html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                  });
                }
              });
            }
          }
        });
      }else{
        this.$swal({
          title: 'Error',
          type: 'error',
          html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
        });
      }
    },
    uploadImage(event){
      this.$refs.uploadImage.images = [];
      this.form.file.value = event[0];
    },
  },
}
</script>